var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip top align-center",staticStyle:{"top":"0"}},[_c('div',{staticClass:"warning"},[_c('p',[_vm._v(_vm._s(_vm.warning))]),(_vm.link)?_c('a',{staticClass:"color-blue-dark",attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v("Read more")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }